import React, { Component } from 'react';



import Container from 'react-bootstrap/Container';




import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';



//import logo from './static/images/logo-simphonie.png';
import logo from './static/images/logo-sp2.png';
//import logo from './static/images/logo-black1.png';
import avatar2 from './static/images/avatar-2.jpeg'
//import logo from './static/images/logo-sm1.jpg';
//import avatar2 from "//ssl.gstatic.com/accounts/ui/avatar_2x.png"



const pages = [
    { 'label': 'Stagiares', 'value': "/students", },
    { 'label': 'Dossiers', 'value': "/dossiers", },
    { 'label': 'Sessions', 'value': "/sessions", },
    { 'label': 'Formations', 'value': "/formations", },
];

const settings = [
    { 'label': 'Profile', 'value': "/profile", },
    { 'label': 'Dashboard', 'value': "/dashboard", },
    { 'label': 'Logout', 'value': "/logout", },
];



//const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];





export default class AppNavbar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            anchorElNav: React.useState < null | HTMLElement > (null),
            anchorElUser: React.useState < null | HTMLElement > (null)
        };
        this.toggle = this.toggle.bind(this);
        this.handleOpenNavMenu = this.handleOpenNavMenu.bind(this);
        this.handleOpenUserMenu = this.handleOpenUserMenu.bind(this);
        this.handleCloseNavMenu = this.handleCloseNavMenu.bind(this);
        this.handleCloseUserMenu = this.handleCloseUserMenu.bind(this);
    }



    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    handleOpenNavMenu(event) {
        this.setState({
            anchorElNav: event.currentTarget
        });
    }

    handleOpenUserMenu(event) {
        //console.log(event);
        this.setState({
            anchorElUser: event.currentTarget
        });
    }

    handleCloseNavMenu(e) {
        //console.log(e);
        this.setState({
            anchorElNav: null
        });
    }




    handleCloseUserMenu(e) {
        this.setState({
            anchorElUser: null
        });
        console.log(e.currentTarget);
    }

    render() {
        const {
            anchorElUser,
            anchorElNav,
        } = this.state;

       

     


        return (
                <AppBar position="static" color="transparent" >
             
                        <Container fluid >
                            
                            <Toolbar disableGutters >
                                <img src={logo} alt="Logo" />
                                
                                <Typography
                                    variant="h5"
                                    noWrap
                                    component="a"
                                    href="/"
                                    sx={{
                                        mr: 8,
                                        display: { xs: 'none', md: 'flex' },
                                        fontFamily: 'monospace',
                                        fontWeight: 700,
                                        letterSpacing: '.3rem',
                                        color: 'inherit',
                                        textDecoration: 'none',
                                    }}
                                >
                                    &nbsp; SIMPHONIE
                                </Typography>

                                <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                                    <IconButton
                                        size="large"
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        onClick={this.handleOpenNavMenu}
                                        color="inherit"
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                    <Menu
                                        id="menu-appbar"
                                        anchorEl={anchorElNav}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        open={Boolean(anchorElNav)}
                                        onClose={this.handleCloseNavMenu}
                                        sx={{
                                            display: { xs: 'block', md: 'none' },
                                        }}
                                    >


                                    </Menu>
                                </Box>

                                <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                                    {pages.map(page => (
                                        <Button
                                            key={page.label}
                                            onClick={this.handleCloseNavMenu}
                                            sx={{ my: 2, color: 'dark', display: 'block' }}
                                            href={page.value}
                                        >
                                            {page.label}
                                        </Button>
                                    ))}


                                </Box>

                                <Box sx={{ flexGrow: 0 }}>
                                    <Tooltip title="Open settings">
                                        <IconButton onClick={this.handleOpenUserMenu} sx={{ p: 0 }}>
                                            <Avatar alt="User" src={avatar2} />
                                        </IconButton>
                                    </Tooltip>
                                    <Menu
                                        sx={{ mt: '45px' }}
                                        id="menu-appbar"
                                        anchorEl={anchorElUser}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={Boolean(anchorElUser)}
                                        onClose={this.handleCloseUserMenu}
                                    >
                                        {settings.map((setting) => (
                                            <MenuItem key={setting.label} onClick={this.handleCloseUserMenu}>
                                                <Button key={setting.label} href={setting.value}>
                                                    {setting.label}
                                                </Button>
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </Box>
                            </Toolbar>
                        </Container>
       
                </AppBar>
        );
    }


}

